// src/App.tsx — UPDATED: 2026-04-27
// ✅ /cursos corrigido (rota dupla removida)
// ✅ /publicacoes/homologacoes e /:id corrigidos (sem / no início)
// ✅ CookieBanner adicionado fora do Routes (aparece em todas as páginas)

import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import CookieBanner from './components/Home/CookieBanner';
import PortalVerificacao from './pages/PortalVerificacao';

import Home          from './pages/Home';
import NotFound      from './pages/NotFound';
import CursoDetalhe  from './pages/CursoDetalhe';

import Historia    from './pages/Institucional/Historia';
import Atribuicoes from './pages/Institucional/Atribuicoes';
import Diretoria   from './pages/Institucional/Diretoria';
import LGPD        from './pages/Institucional/LGPD';
import Comissoes   from './pages/Institucional/Comissoes';

import Filiacao      from './pages/Filiacao';
import Classificacao from './pages/Classificacao';

import Servicos                 from './pages/Servicos';
import SolicitarDiploma         from './pages/SolicitarDiploma';
import CosmetologoInternacional from './pages/CosmetologoInternacional';
import RevalidaPro              from './pages/RevalidaPro';
import Landing                  from './pages/Landing';

import Cursos from './pages/Cursos';

import Publicacoes        from './pages/Publicacoes';
import Noticias           from './pages/Noticias';
import Profissionais      from './pages/Profissionais';
import PremiacoesEventos  from './pages/PremiacoesEventos';
import Homologacoes       from './pages/Homologacoes';
import NoticiaDetalhes    from './pages/NoticiaDetalhes';
import HomologacaoDetalhe from './pages/HomologacaoDetalhe';
import AcoesSociais from './pages/AcoesSociais';


import EscolasAssociadas from './pages/EscolasAssociadas';
import FaleConosco       from './pages/FaleConosco';
import Links             from './pages/Links';

import LoginAluno    from './pages/LoginAluno';
import LoginAfiliado from './pages/LoginAfiliado';
import LoginADM      from './pages/LoginADM';

import PortalAluno    from './pages/PortalAluno';
import PortalAfiliado from './pages/PortalAfiliado';
import DashboardADM   from './pages/DashboardADM';

import ProtectedRoute from './components/Auth/ProtectedRoute';
import { useAuth } from './hooks/useAuth';

const App: React.FC = () => {
  // Valida a sessão persistida e atualiza o perfil completo (/auth/me) em
  // qualquer rota, inclusive após recarregamento ou novo deploy.
  useAuth();

  return (
    <>
      <Routes>

        {/* ── PÚBLICAS (com layout) ─────────────────────────────────────── */}
        <Route element={<Layout />}>
          <Route index element={<Home />} />
         
          <Route path="institucional">
            <Route path="historia"    element={<Historia />} />
            <Route path="atribuicoes" element={<Atribuicoes />} />
            <Route path="diretoria"   element={<Diretoria />} />
            <Route path="lgpd"        element={<LGPD />} />
            <Route path="comissoes"   element={<Comissoes />} />
          
          </Route>
 
          <Route path="filiacao">
            <Route index                element={<Filiacao />} />
            <Route path="classificacao" element={<Classificacao />} />
          </Route>

          <Route path="servicos">
            <Route index              element={<Servicos />} />
            <Route path="diploma"     element={<SolicitarDiploma />} />
            <Route path="cosmetologo" element={<CosmetologoInternacional />} />
            <Route path="revalida"    element={<RevalidaPro />} />
            <Route path="site"        element={<Landing />} />
          </Route>

          <Route path="cursos"     element={<Cursos />} />
          <Route path="cursos/:id" element={<CursoDetalhe />} />

          <Route path="publicacoes">
            <Route index                   element={<Publicacoes />} />
            <Route path="artigos"          element={<Publicacoes />} />
            <Route path="revista"          element={<Publicacoes />} />
            <Route path="profissionais"    element={<Profissionais />} />
            <Route path="eventos"          element={<PremiacoesEventos />} />
            <Route path="homologacoes"     element={<Homologacoes />} />
            <Route path="homologacoes/:id" element={<HomologacaoDetalhe />} />
          </Route>

          <Route path="noticias"       element={<Noticias />} />
          <Route path="noticias/:slug" element={<NoticiaDetalhes />} />
<Route path="acoes-sociais"  element={<AcoesSociais />} />

          <Route path="escolas"      element={<EscolasAssociadas />} />
          <Route path="fale-conosco" element={<FaleConosco />} />
        </Route>
        {/* ── LINKS (bio Instagram — standalone, sem Layout) ───────────── */}
        <Route path="links" element={<Links />} />
        <Route path="link" element={<Links />} />

        {/* ── VERIFICAÇÃO PÚBLICA ─────────────────────────────────────── */}
        <Route path="verificar" element={<PortalVerificacao />} />
        <Route path="verificar/:protocolo" element={<PortalVerificacao />} />
        {/* ── AUTH ──────────────────────────────────────────────────────── */}
        <Route path="login">
          <Route path="aluno"   element={<LoginAluno />} />
          <Route path="filiado" element={<LoginAfiliado />} />
        </Route>
        <Route path="login-adm"   element={<LoginADM />} />
        <Route path="login-admin" element={<LoginADM />} />

        {/* ── PORTAIS PROTEGIDOS ────────────────────────────────────────── */}
        <Route path="portal/aluno"
          element={<ProtectedRoute allowedRoles={['student']}><PortalAluno /></ProtectedRoute>}
        />
        <Route path="portal/filiado"
          element={<ProtectedRoute allowedRoles={['affiliate']}><PortalAfiliado /></ProtectedRoute>}
        />
        <Route path="admin"
          element={<ProtectedRoute allowedRoles={['admin']}><DashboardADM /></ProtectedRoute>}
        />
        <Route path="dashboard-adm"
          element={<ProtectedRoute allowedRoles={['admin']}><DashboardADM /></ProtectedRoute>}
        />

        <Route path="*" element={<NotFound />} />
      </Routes>

      {/* ✅ Fora do Routes — aparece em todas as páginas */}
      <CookieBanner />
    </>
  );
};

export default App;
